import { z } from "zod";

export interface FinancialMovementDesc {
  id: number;
  nroComprobante: number;
  descripcion: string;
}

export const mfdFilterSchema = z.object({
  name: z.any().optional(),
  code: z.any().optional(),
});
